module.exports = __webpack_public_path__ + "static/images/flag-vietnam.6sC5JvS.svg";